import React, { useContext, useState } from 'react'
import { PanelDeControlContext } from '../../../context/PanelDeControlContext';
import apiUploads from '../../../services/apis/apiUploads';
import style from './style.module.css'

const SubirConstancia = ({ onSuccess }) => {

    const { eventoSeleccionado } = useContext( PanelDeControlContext );
    const [ selectedFile, setSelectedFile ] = useState();
    const [ mensajeError, setMensajeError ] = useState();

    const types = [
        'application/pdf',
    ];

    const changeHandler = (e) => {
        const file = e.target.files[0] || null;
        if ( !types.includes(file.type) ) { return setMensajeError('Selecciona un archivo válido, por el momento solo aceptamos archivos PDF') }
        setSelectedFile(file)
    }

    const submitFile = async() => {
        if( !selectedFile ){ return setMensajeError('Selecciona un archivo válido por el momemnto solo aceptamos archivos PDF') }

        const formData = new FormData();
        formData.append('archivo', selectedFile);

        const response = await apiUploads.subirConstancia(eventoSeleccionado._id, formData );
        if ( response.error ){ return setMensajeError(response.errorMsg)}

        onSuccess(response.data)

    }

    return (<>
        
        <div className="row">
            <div className="col-auto">
                <input
                    onChange={ changeHandler }
                    type="file" name="file" id=""  className='form-control'/>
            </div>
            <div className="col-auto">
                <button
                    onClick={ submitFile }
                    className={ `btn btn-primary ${ style.botonAgregarAsistentes }` }>
                    Subir Constancia
                </button>
            </div>
        </div>

        {mensajeError &&
            <div className="container-fluid p-2 mt-3 bg-warning">
                <p>{ mensajeError }</p>
            </div>
        }

    </>)
}

export default SubirConstancia
